<template>
    <div class="no-logo">
        <img src="/ressources/logged/img/common/defaultNoLogo.png" class="no-logo__default-logo" />
        <CompassButton
            class="no-logo__button"
            :label="$t.__('appearance.noLogo.add_logo_button')"
            @click="displayConfirmModal = true"
        />

        <CompassModal
            v-model:visible="displayConfirmModal"
            class="no-logo__modal"
            :title="$t.__('appearance.noLogo.confirm_modal_title')"
            size="small"
            @closed="displayConfirmModal = false"
        >
            <template #default>
                <p class="no-logo__modal-description typographies-paragraph-medium-regular">
                    {{ $t.__('appearance.noLogo.confirm_modal_description') }}
                </p>
            </template>

            <template #footer>
                <div class="no-logo__modal-footer">
                    <CompassButton
                        class="no-logo__modal-button"
                        type="secondary"
                        :label="$t.__('common.actions.cancel')"
                        @click="displayConfirmModal = false"
                    />
                    <CompassButton
                        class="no-logo__modal-button"
                        type="primary-destructive"
                        :label="$t.__('appearance.noLogo.confirm_modal_continue_button')"
                        @click="goToUrl('/?_f=companyPreferences&action=logo')"
                    />
                </div>
            </template>
        </CompassModal>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
export default {
    data() {
        return {
            displayConfirmModal: false,
        };
    },
    methods: {
        goToUrl,
    },
};
</script>

<style lang="scss" scoped>
.no-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 180px;
    height: 160px;

    &__default-logo {
        display: inline-block;
        height: auto;
        max-width: 145px;
        margin-bottom: 0 !important;
    }

    &__modal {
        &-description {
            margin: 0;
        }

        &-footer {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            padding: var(--spacing-4) var(--spacing-5) var(--spacing-5);
        }
    }
}
</style>
